import { XSAuthProvider } from "@xinosolutions/xs-auth-react";
import { ProductProvider } from "../../context/ProductContext";
import {
  xsAuthBootstrapUrl,
  xsAuthClientId,
  xsAuthUrl,
  xsAccountUrl,
} from "../../config/config";

/** Same stack as xs-website-web-app: XSAuthProvider → ProductSessionProvider. */
export default function AdminProviders({ children }) {
  return (
    <XSAuthProvider
      clientId={xsAuthClientId}
      authBaseUrl={xsAuthUrl}
      bootstrapUrl={xsAuthBootstrapUrl}
      accountUrl={xsAccountUrl}
    >
      <ProductProvider>{children}</ProductProvider>
    </XSAuthProvider>
  );
}
